import React from "react";
import Figure1 from "./Figure1";
import Figure2 from "./Figure2";
import Figure3 from "./Figure3";
import Figure6 from "./Figure6";
import Figure9 from "./Figure9";
import Figure10 from "./Figure10";

const Article = () => {
  return (
    <div>
      <div className="mb-20">
        <p>
          The final probiotic would contain two plasmids for the respective
          expression of the EC20 gene and SpaC gene. In order to developp it, we
          tested those two parts individually and then together.{" "}
        </p>
        <p>
          Moreover, the desired probiotic has been engineered to prevent
          horizontal gene transfer. Thus, the notebook have been devided in four
          sections :
          <ul className="ml-12 mb-10"
          style={{ listStyleType: "disc", listStylePosition: "inside" }}>
            <li> EC20 experiments </li>
            <li> SpaC experiments </li>
            <li> Horizontal Gene Transfer prevention experiments </li>
          </ul>
        </p>
        <br></br>

        <h2 id="Intro-SpaC_s"> SpaC </h2>
        <br></br>
        <table>
          <tbody>
            <tr>
              <td>Plasmid</td>
              <td>pTwist Kan high copy</td>
            </tr>
            <tr>
              <td>Resistance</td>
              <td>Kanamycin</td>
            </tr>
            <tr>
              <td>Tag</td>
              <td>Flag</td>
            </tr>
            <tr>
              <td>Expression system</td>
              <td>IPTG & Theophylline</td>
            </tr>
          </tbody>
        </table>
        <br></br>

        <h2 id="Transformation1-SpaC_s">Transformation of SpaC plasmid</h2>
        <div className="date">21/07/2023</div>
        <p>
          <u>Aim:</u> Incorporation of the SpaC plasmid in DH5α and BL21 E. Coli
          competent strains. The DH5α transformed bacteria are used to amplify
          the plasmid and the BL21 transformed bacteria to produce the SpaC
          protein.
        </p>
        <p><u>Protocol:</u> Bacterial Transformation</p>
        <p>
          <u>Results:</u> After the plasmid rehydratation with 100µL of water, a
          concentration of 113 ng/µL was measured using a Nanodrop.
        </p>
        <p> Both transformations worked. </p>
        <br></br>

        <h2 id="Primary1-SpaC_s">
          Primary Culture of BL21 and DH5α containing SpaC plasmid
        </h2>
        <div className="date">23/07/2023</div>
        <p>
          <u>Aim:</u> Growing the DH5α and BL21 transformed bacteria.
        </p>
        <p>
          <u>Protocol:</u> Primary culture
        </p>
        <br></br>

        <h2 id="Glycerol1-SpaC_s"> Glycerol stock of BL21 containing SpaC</h2>
        <div className="date">23/07/2023</div>
        <p>
          <u>Aim:</u> Make a stock of BL21 containing SpaC{" "}
        </p>
        <p>
          <u>Protocol:</u> Glycerol stock
        </p>
        <br></br>

        <h2 id="Miniprep-SpaC_s"> Miniprep of DH5α cells with SpaC</h2>
        <div className="date">24/07/2023</div>
        <p>
          <u>Aim:</u> Collecting the SpaC plasmids from the transformed DH5α
          bacteria to be used for further transformations.
        </p>
        <p>
          <u>Protocol:</u> Miniprep
        </p>
        <p>
          <u>Results:</u> We obtained a stock of 247ng/µL plasmid DNA.{" "}
        </p>
        <br></br>

        <h2 id="Glycerol2-SpaC_s"> Glycerol stock of DH5α containing SpaC</h2>
        <div className="date">24/07/2023</div>
        <p><u>Aim:</u> Make a stock of BL21 containing SpaC </p>
        <p><u>Protocol:</u> Glycerol stock</p>
        <br></br>

        <h2 id="Secondary1a-SpaC_s">Secondary culture of BL21 containing SpaC</h2>
        <div className="date">27/07/2023</div>
        <p>
          <u>Aim:</u> Test different culture conditions for SpaC expression.
        </p>
        <p>
          <u>Protocol:</u> Secondary Culture
        </p>
        <p>
          In the first culture, Theophylline was added but not in the second
          one.
        </p>
        <p>
          {" "}
          - 1st condition: 21,25mL of LB, 2 mL of primary culture and 1,25 mL of
          theophylline
        </p>
        <p>- 2nd condition: 24 mL of LB and 2,5 mL of primary culture</p>
        <p>
          <u>Results:</u> The experiment did not work, cultures were still
          translucid after 16 hours.
        </p>
        <p>
          <u>Possible issue:</u> Theophylline was crystallized before use. For
          next trial, we will heat Theophylline at 37°C before use.
        </p>
        <br></br>

        <h2 id="SurfaceExpression1-SpaC_s"> Surface Expression Assay by GFP binding </h2>
        <div className="date">23/07/2023: <mark className="date-text">Primary Culture</mark></div>
        <div className="date">27/07/2023: <mark className="date-text">Secondary Culture and Induction</mark>
        <br/><u>Conditions:</u>
        <p>Three different conditions were incubated with GFP. </p>
        - Condition 1: Theophylline+ (early), IPTG+ <br/>
        - Condition 2: theophylline+ (late), IPTG+ <br/>
        - Condition 3: Negative Control, Theophylline-, IPTG-
        </div>
        <div className="date">23/07/2023: <mark className="date-text">Surface Expression Assay</mark></div>
        <p><u>Aim:</u> The SpaC construct also has a GFP nanobody, enabling GFP to 
          bind to the bacteria producing SpaC protein at it surface.</p>
        <p><u>Protocol:</u> GFP assay</p>
        <p> <u>Results:</u> (in fluorescence unit) </p>
        <p>The results are not conclusive as the Fluorescence level of Negative Control  is inbetween the Fluorescence level of the two conditions.</p>
        <Figure1/>
        <br></br>

        <h2 id="Secondary1b-SpaC_s">
          {" "}
          Secondary culture SpaC in BL21 containing, induction with IPTG
        </h2>
        <div className="date">28/07/2023</div>
        <p>
          <u>Aim:</u> Induce SpaC production with IPTG.
        </p>
        <p>
          <u>Protocol:</u> Secondary culture
        </p>
        <p>Two cultures were done:</p>
        <p>- 1st culture : with theophylline </p>
        <p>- 2nd culture : negative control, no theophylline</p>
        <p>
          <u>Results:</u>
          <Figure2 />
        </p>
        <br></br>


        <h2 id="ProteinaseK-SpaC_s"> Proteinase K experiment SpaC </h2>
        <div className="date">08/08/2023: <mark className="date-text">Primary Culture</mark></div>
        <div className="date">09/08/2023: <mark className="date-text">Secondary Culture</mark>
        <br/>Secondary Cultutres induced with IPTG when OD reached 0,4</div>
        <div className="date">11/08/2023: <mark className="date-text">ProteinaseK Experiment</mark></div>
        <p><u>Aim:</u> Use proteinase K to digest SpaC protein and measure its
          presence at the surface of the cell.</p>
        <p><u>Protocol:</u> Proteinase K assay</p>
        <p> Three conditions were tested :
          <p>Condition 1: Bacterial culture + 20µg/mL GFP + PK (100µg/mL) + Proteinase Inhibitor Cocktail (200µg/mL) </p>
          <p>Condition 2: Bacterial Culture - Loading Control </p>
          <p>Condition 3: Bacterial culture + 20µg/mL GFP + Proteinase Inhibitor Cocktail (200µg/mL) - Fluorescence Control </p></p>
        <p><u>Results:</u> The fluorescence have been measured after 21h of incubation with
          proteinase K, but no difference in fluorescence levels was observed. </p>
        <Figure3 />
        <p><u>Figure 4:</u> Ponceau S (left) and WesternBlot (right)<img
              src="https://static.igem.wiki/teams/4888/wiki/pk-1108.jpg"
              style={{
                paddingTop: "15px",
                paddingBottom: "15px",
                width: "45%",
                height: "auto",
              }}
              alt="Result Figure"
            /></p>
        <br></br>

        <h2 id="SurfaceExpression2-SpaC_s">Surface Expression Assay by GFP Binding</h2>
        <div className="date">08/08/2023: <mark className="date-text">Primary Culture</mark></div>
        <div className="date">09/08/2023: <mark className="date-text">Secondary Culture</mark>
        </div>
        <div className="date">11/08/2023</div>
        <p><u>Aim:</u> The SpaC construct also has a GFP nanobody, enabling GFP to 
          bind to the bacteria producing SpaC protein at it surface. </p>
        <p><u>Protocol:</u> GFP assay</p>
        <p><u>Results:</u> <table class="equal-width-table">
          <thead>
            <tr>
              <th> GFP \ bacteria culture volume​ </th>
              <th> 1 mL </th>
              <th> O.5 mL </th>
              <th> 0.25 mL </th>
              <th> 0.125 mL </th>
            </tr>
          </thead>
          <tbody>
          <tr>
              <th> 0 µg/mL</th>
              <td> OD:1,29  F:1598 </td>
              <td> OD:0,86  F:1054  </td>
              <td> OD:0,41  F:1050 </td>
              <td> OD:0,14  F:1576 </td>
            </tr>            
            <tr>
              <th> 30 µg/mL</th>
              <td> OD:1,27  F:2088 </td>
              <td> OD:0,88  F:1274 </td>
              <td> OD:0,50  F:1072 </td>
              <td> OD:0,16  F:1446 </td>
            </tr>
            <tr>
              <th> 60 µg/mL</th>
              <td> OD:1,27  F:2106 </td>
              <td> OD:0,88  F:1324 </td>
              <td> OD:0,47  F:1100 </td>
              <td> OD:0,14  F:1586 </td>
            </tr>
            <tr>
              <th> 120 µg/mL</th>
              <td> OD:1,30  F:2228</td>
              <td> OD:0,88  F:1346</td>
              <td> OD:0,43  F:1088</td>
              <td> OD:0,15  F:1458</td>
            </tr>
          </tbody>
        </table>
 </p>
        <br></br>
        <h2 id="Halflife1-SpaC_s">Half-life of SpaC </h2>
        <div className="date">08/08/2023: <mark className="date-text">Primary Culture</mark></div>
        <div className="date">09/08/2023: <mark className="date-text">Secondary Culture</mark></div>
        <div className="date">12/08/2023: <mark className="date-text">Half Life Experiment</mark></div>
        <p><u>Aim:</u> Determine the half-life of the SpaC protein.</p>
        <p><u>Protocol:</u> Half-life</p>
        <mark className="date"><u>Time Points with Glucose Conditions:</u><br/>
        Glucose+: <br/>- 0 hours  - 6 hours  - 12 hours  - 24 hours  - 36 hours  - 48 hours<br/>
        Glucose-: <br/>- 0 hours  - 6 hours  - 12 hours  - 24 hours  - 36 hours  - 48 hours<br/>
        </mark>
        <p><u>Results:</u>
        <p><u>Figure 5:</u> Western Blot and PonceauS of SpaC incubated with Glucose untill different time points</p>
        <p>PonceauS:</p>
        <img src="https://static.igem.wiki/teams/4888/wiki/hl-1208pons.jpg"
              style={{
                paddingTop: "15px",
                paddingBottom: "15px",
                width: "45%",
                height: "auto",
              }}
              alt="Result Figure"/>
        <p>Western Blot:</p>
        <img src="https://static.igem.wiki/teams/4888/wiki/hl-1208wb.jpg"
              style={{
                paddingTop: "15px",
                paddingBottom: "15px",
                width: "45%",
                height: "auto",
              }}
              alt="Result Figure"/> 
              </p>
              
        <br></br>

        <h2 id="Secondary3-SpaC_s">Secondary culture of BL21 containing SpaC </h2>
        <div className="date">12/08/2023</div>
        <p>
          <u>Aim:</u> Test different culture and induction conditions for BL21
          with SpaC.
        </p>
        <p><u>Protocol:</u> Secondary Culture</p>
        <p>The six conditions are summed up in the following table:</p>
        <br></br>
        <table>
          <thead>
            <tr>
              <th></th>
              <th>Dilutions</th>
              <th>Theophylline</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>1/2</td>
              <td>No</td>
            </tr>
            <tr>
              <td>2</td>
              <td>1/2</td>
              <td>Yes</td>
            </tr>
            <tr>
              <td>3</td>
              <td>1/5</td>
              <td>No</td>
            </tr>
            <tr>
              <td>4</td>
              <td>1/5</td>
              <td>Yes</td>
            </tr>
            <tr>
              <td>5</td>
              <td>1/10</td>
              <td>No</td>
            </tr>
            <tr>
              <td>6</td>
              <td>1/10</td>
              <td>Yes</td>
            </tr>
          </tbody>
        </table>
        <br></br>
        <p>
          <u>Results:</u>
        </p>
        <Figure6 />
        <p>We observe that Theophylline slows the growth of our bacteria.</p>
        <br></br>
      


        <h2 id="Sonication-ProteinaseK-assay-SpaC_s"> Sonication & Proteinase K assay </h2>
        <div className="date">14/08/2023<mark className="date-text">Sonification</mark></div>
        <p>
          <u>Aim:</u> Determine the half-life of the SpaC protein expressed at
          the surface.
        </p>
        <br></br>
        <p>Western map:</p>
        <table class="equal-width-table">
          <thead>
            <tr>
              <th> Well 1 </th>
              <th> Well 2 </th>
              <th> Well 3 </th>
              <th> Well 4 </th>
              <th> Well 5 </th>
              <th> Well 6 </th>
              <th> Well 7 </th>
              <th> Well 8 </th>
              <th> Well 9 </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td> SpaC </td>
              <td> SpaC </td>
              <td> SpaC </td>
              <td> Ladder </td>
              <td> </td>
              <td> Ladder </td>
              <td> EC20 </td>
              <td> EC20 </td>
              <td> EC20 </td>
            </tr>
            <tr>
              <td> TP0 </td>
              <td> PK- </td>
              <td> PK+ </td>
              <td> </td>
              <td> </td>
              <td> </td>
              <td> TP0 </td>
              <td> PK- </td>
              <td> PK+ </td>
            </tr>
          </tbody>
        </table>
        <br></br>
        <p><u>Protocol:</u> Proteinase K assay</p>
        <p>
          <u>Results:</u> We don't observe any signal for His antibody,
          sonication is not promising.
        </p>
        <br></br>
        <h2 id="Immunofluorescence-SpaC_s"> Immunofluorescence Assay</h2>
        <div className="date">19/08/2023: <mark className="date-text">Primary Culture</mark></div>
        <div className="date">20/08/2023: <mark className="date-text">Secondary Culture</mark></div>
        <div className="date">21/08/2023: <mark className="date-text">Incubation </mark></div>
        <div className="date">21/08/2023: <mark className="date-text">Immunofluorescence</mark></div>
        <p><u>Aim:</u> Check surface expression of SpaC protein with Anti-Flag tag antibody. </p>
        <p><u>Protocol:</u> Immunofluorescence for surface expression verification</p>
        <p>We used as a negative control a primary culture of EC20.</p>
        <p><u>Results:</u> Failed. </p>
        <p>See in Results:<a href="https://2023.igem.wiki/epfl/results#Surface_Display_SpaC_s">Surface display of SpaC</a></p>
        <br></br>

        <h2 id="Halflife2-SpaC_s">Half-Life of SpaC</h2>
        <div className="date">19/08/2023: <mark className="date-text">Primary Culture</mark></div>
        <div className="date">21/08/2023: <mark className="date-text">Secondary Culture</mark></div>
        <div className="date">22/08/2023: <mark className="date-text">Incubation </mark></div>
        <div className="date">23/08/2023: <mark className="date-text">Half-Life Experiment</mark></div>
        <p><u>Aim:</u> Determine the half-life of the SpaC protein over a longer periode of time.</p>
        <p><u>Protocol:</u> Half-life</p>
        <mark className="date"><u>Time Points:</u><br/>
        - 0 hours  - 24 hours  - 48 hours  - 72 hours  - 96 hours  - 120 hours  - 144 hours  - 168 hours  - 192 hours
        </mark>
        <p><u>Results:</u> </p>
        <p><u>Figure 7:</u> Western Blot and PonceeauS of SpaC incubated until different time points</p>
        <p>Ponceau S:</p>
        <img src="https://static.igem.wiki/teams/4888/wiki/hl-2308pons.jpg"
              style={{
                paddingTop: "15px",
                paddingBottom: "15px",
                width: "45%",
                height: "auto",
              }}
              alt="Result Figure"/>
        <p>Western Blot:</p>
        <img src="https://static.igem.wiki/teams/4888/wiki/hl-2308wb.jpg"
              style={{
                paddingTop: "15px",
                paddingBottom: "15px",
                width: "45%",
                height: "auto",
              }}
              alt="Result Figure"/> 
        <br></br>
        <h2 id="Mucusbinding-SpaC_s"> Mucus binding experiment </h2>
        <div className="date">23/08/2023: <mark className="date-text">Primary Culture</mark></div>
        <div className="date">23/08/2023: <mark className="date-text">Secondary Culture</mark></div>
        <div className="date">24/08/2023: <mark className="date-text">Incubation </mark></div>
        <div className="date">23/08/2023: <mark className="date-text">Half-Life Experiment</mark></div>
        <p><u>Aim:</u> Check for surface expression of shortened SpaC by testing its adhesion to mucus</p>
        <p><u>Protocol:</u> Mucus Binding</p>
        <p><u>Results:</u> Non conclusive as the colony count ratio between SpaC and His Control remains the same regardless of its presence on a mucus chip.
<br/>
        SpaC on Mucus chip:
        <table class="table-with-headers">
          <thead>
            <tr>
              <th></th>
              <th colSpan={"3"}>Mucus+</th>
              <th colSpan={"3"}>Mucus-</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Dilution</th> 
              <td>1:1</td>
              <td>1:10</td>
              <td>1:100</td>
              <td>1:1</td>
              <td>1:10</td>
              <td>1:100</td>
            </tr>
            <tr>
              <th>Colony Count</th> 
              <td>291</td>
              <td>40</td>
              <td>5</td>
              <td>140</td>
              <td>15</td>
              <td>1</td>
            </tr>
          </tbody>
        </table>
        His Control on Mucus chip:
        <table class="table-with-headers">
          <thead>
            <tr>
              <th></th>
              <th colSpan={"3"}>Mucus+</th>
              <th colSpan={"3"}>Mucus-</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Dilution</th> 
              <td>1:1</td>
              <td>1:10</td>
              <td>1:100</td>
              <td>1:1</td>
              <td>1:10</td>
              <td>1:100</td>
            </tr>
            <tr>
              <th>Colony Count</th> 
              <td>~700</td>
              <td>153</td>
              <td>25</td>
              <td>~700</td>
              <td>213</td>
              <td>33</td>
            </tr>
          </tbody>
        </table>
        Droplets:
        <table class="table-with-headers">
          <thead>
            <tr>
              <th></th>
              <th>1:10</th>
              <th>1:100</th>
              <th>1:1000</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>SpaC</th> 
              <td>31</td>
              <td>8</td>
              <td>0</td>
            </tr>
            <tr>
              <th>His</th> 
              <td>110</td>
              <td>18</td>
              <td>4</td>
            </tr>
          </tbody>
        </table>

        </p>
        <br></br>

        <h2 id="ImmunofluorescenceGFP-SpaC_s"> Immunofluorescence GFP nanobody version</h2>
        <div className="date">23/08/2023</div>
        <p>
          <u>Aim:</u> Check surface expression of SpaC protein by binding GFP to
          the GFP nanobody.
        </p>
        <p>
          <u>Protocol:</u> Immunofluorescence GFP nanobody version. 8 conditions
          were tested:
        </p>
        <table class="equal-width-table">
          <thead>
            <tr>
              <th>GFP concentration</th>
              <th>Test incubation 1h</th>
              <th>Test incubation overnight</th>
              <th>Negative Control</th>
              <th>Positive Control</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>2 mg/mL</td>
              <td>SpaC induced</td>
              <td>SpaC induced</td>
              <td>SpaC not induced</td>
              <td>SpaC induced + Lysozyme treatment</td>
            </tr>
            <tr>
              <td>0.2 mg/mL</td>
              <td>SpaC induced</td>
              <td>SpaC induced</td>
              <td>SpaC not induced</td>
              <td>SpaC induced + Lysozyme treatment</td>
            </tr>
          </tbody>
        </table>
        <br></br>
        <p>
          <u>Results:</u> Failed. (again..)
        </p>
        <p>See in Results:<a href="https://2023.igem.wiki/epfl/results#Surface_Display_SpaC_s"> Surface display of SpaC </a></p>
        <br></br>
        <h2 id="Shortening1-SpaC_s"> Shortening of SpaC: D1 & D2 domains </h2>
        <div className="date">13/09/2023</div>
        <p>
          <u>Aim:</u> Reduce the size of the SpaC protein.
        </p>
        <p>
          <u>Protocol:</u> HiFi Cloning
        </p>
        <p>
          <u>Results:</u> We obtained a construct without the stalk domain of
          the SpaC protein.
        </p>
        <br></br>
        <h2 id="Shortening2-SpaC_s"> Shortening of SpaC: D2 domains </h2>
        <div className="date">13/09/2023</div>
        <p>
          <u>Aim:</u> Reduce the size of the SpaC protein.{" "}
        </p>
        <p>
          <u>Protocol:</u> KLD Cloning
        </p>
        <p>
          <u>Results:</u> We obtained a construct with only the D2 domain of the
          SpaC protein.
        </p>
        <br></br>
        
        <br/><h2>SpaC - D2 and D1&D2 domains</h2><br/><br/>

        <h2 id="Primary5-SpaC_s">Primary Culture of BL21 containing shortened SpaC plasmid: D2 and D1&D2 domains </h2>
        <div className="date">22/09/2023</div>
        <p>
          <u>Aim:</u> Growing the BL21 transformed bacteria.
        </p>
        <p>
          <u>Protocol:</u> Primary culture
        </p>
        <br></br>

        <h2 id="Secondary5-SpaC_s"> Secondary culture of BL21 containing shortened SpaC - D2 and D1&D2 domains</h2>
        <div className="date">23/09/2023</div>
        <p>
          <u>Aim:</u> Grow BL21 with SpaC in presence of Theophylline and induce
          SpaC production with IPTG.
        </p>
        <p>
          <u>Protocol:</u> Secondary culture
        </p>
        <p>
          <u>Results:</u> Culture used when OD exceeded 0.4.{" "}
        </p>
        <br></br>

        <h2 id="Glycerol3-SpaC_s"> Glycerol stock of BL21 containing shortened SpaC - D2 and D1&D2 domains</h2>
        <div className="date">23/09/2023</div>
        <p>
          <u>Aim:</u> Make a stock of BL21 containing shortened SpaC, with only
          the D1 and D2 domains.
        </p>
        <p>
          <u>Protocol:</u> Glycerol stock
        </p>
        <br></br>

        <h2 id="Miniprep2-SpaC_s"> Miniprep of BL21 containing shortened SpaC - D2 and D1&D2 domains</h2>
        <div className="date">23/09/2023</div>
        <p><u>Aim:</u> Collecting the shortened SpaC plasmids - D2 and D1&D2 domains - from the BL21 cells.</p>
        <p><u>Protocol:</u> Miniprep</p>
        <p><u>Results:</u> D1&D2: We obtained a stock of 406ng/µL plasmid DNA. Which we diluted x4 to yield a concentration of 102ng/µL.</p>
        <p>D2: We obtained a stock of 260ng/µL plasmid DNA. Which we diluted x2 to yield a concentration of 155ng/µL.</p>
        <br></br> 

        <h2 id="Transformation2-SpaC_s"> Transformation of shortened SpaC - D2 and D1&D2 domains </h2>
        <div className="date">24/09/2023</div>
        <p><u>Aim:</u> Incorporation of the modified SpaC plasmid in BL21 E. Coli
          competent strains. The BL21 transformed bacteria are used to produce the shortened SpaC protein (D2 domain).</p>
        <p><u>Protocol:</u> Bacterial Transformation</p>
        <p><u>Results:</u> D2: Initial Plasmid concentration: 155ng/µL <br/> 
                          Mixed 1ul of Plasmid with 1 ul of nuclease free water. <br/>
                          Working concentration: 77,5ng/ul. <br/>
                          D1&D2: Initial Plasmid concentration: 102ng/µL <br/> 
                          Mixed 2ul of Plasmid with 1 ul of nuclease free water. <br/>
                          Working concentration: 68ng/ul.</p>
        <br></br>

        <h2 id="Mucusbinding2-SpaC_s"> Mucus Binding Experiment </h2>
        <div className="date">25/09/2023: <mark className="date-text">Primary Culture of Batch 1</mark></div>
        <div className="date">26/09/2023: <mark className="date-text">Primary Culture of Batch 2</mark></div>
        <div className="date">26/09/2023: <mark className="date-text">Secondary Culture of Batch 1</mark></div>
        <div className="date">27/09/2023: <mark className="date-text">Secondary Culture of Batch 2</mark></div>
        <div className="date">26/09/2023: <mark className="date-text">Induction of Batch 1</mark></div>
        <div className="date">27/09/2023: <mark className="date-text">Induction of Batch 2</mark></div>
        <mark className="date"><u>Note:</u> <br/>
                                            - Batch 1 was Grown on the 25/09, Induced on the 26/09, Stored @4°C for 20h and 17h (resp. D1&D2 and D2) and 1h @RT<br/>
                                            - Batch 2 was Grown on the 26/09, Induced on the 27/09, Stored @4°C for 2h (D1&D2 and D2) and 1h @RT</mark>
        <div className="date">27/09/2023: <mark className="date-text">Mucus Binding Experiment</mark></div>
        <p><u>ODs:</u>
        <table class="table-with-headers">
          <thead>
            <tr>
              <th></th>
              <th>D1&D2</th>
              <th>D2</th>
              <th>Control (unshortened SpaC)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th class="vertical-header">Batch 1</th> 
              <td>0,52</td>
              <td>0,517</td>
              <td>0,311</td>
            </tr>
            <tr>
              <th class="vertical-header">Batch 2</th> 
              <td>0,736</td>
              <td>0,716</td>
              <td>0,739</td>
            </tr>
          </tbody>
</table></p>
        <p><u>Aim:</u> Check for surface expression of shortened SpaC (D1&D2 and D2) by testing its adhesion to mucus</p>
        <p><u>Protocol:</u> Mucus Binding</p>
        <p><u>Results:</u> Plates were empty because OD was too low. It turns out the OD reader was deficient and printed out values lower than actual OD, wich lead to bacteria dying due to overpopulation..</p>
        <br></br>

        <h2 id="Western-SpaC_s"> Western Blot of shortened SpaC - D1&D2 domain and D2 domain </h2>
        <div className="date">25/09/2023: <mark className="date-text">Primary Culture of Batch 1</mark></div>
        <div className="date">26/09/2023: <mark className="date-text">Primary Culture of Batch 2</mark></div>
        <div className="date">26/09/2023: <mark className="date-text">Secondary Culture of Batch 1</mark></div>
        <div className="date">27/09/2023: <mark className="date-text">Secondary Culture of Batch 2</mark></div>
        <div className="date">26/09/2023: <mark className="date-text">Induction of Batch 1</mark></div>
        <div className="date">27/09/2023: <mark className="date-text">Induction of Batch 2</mark></div>
        <mark className="date"><u>Note:</u> <br/>
                                            - Batch 1 and Batch 2 refer to the same cutures as previous experiment<br/>
                                            - Here unshortened SpaC protein acts as a  </mark>
        <div className="date">27/09/2023: <mark className="date-text">Western Blot</mark></div>
        <p><u>Aim:</u> This has been done in parallel to the Mucus Binding experiment to verify that shortened SpaC (D1&D2 and D2) are indeed expressed. </p>
        <p><u>Protocol:</u> Western Blot</p>
        <p>Loading map:</p>
        <table class="equal-width-table">
          <thead>
            <tr>
              <th> Well 1 </th>
              <th> 2 </th>
              <th> 3 </th>
              <th> 4 </th>
              <th> 5 </th>
              <th> 6 </th>
              <th> 7 </th>
              <th> 8 </th>
              <th> 9 </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td> Ladder </td>
              <td> - </td>
              <td> D2 (Batch 1) </td>
              <td> D1D2 (Batch 1) </td>
              <td> SpaC (Batch 1) </td>
              <td> - </td>
              <td> D2 (Batch 2) </td>
              <td> D1D2 (Batch 2) </td>
              <td> SapC (Batch 2)</td>
            </tr>
          </tbody>
        </table>
        <p><u>Results:</u> SpaC-D2 and SpaC-D1D2 are expressed. </p>
        <p><u>Figure 8:</u> Western Blot (left) and PonceauS (right) of D2 and D1D2 domains</p>
        <p>PonceauS:</p>
        <img src="https://static.igem.wiki/teams/4888/wiki/wb-2709.jpg"
              style={{
                paddingTop: "15px",
                paddingBottom: "15px",
                width: "45%",
                height: "auto",
              }}
              alt="Result Figure"/>
        <br></br>

        <h2 id="Test-OD-Meter_s"> Test OD meter </h2>
        <div className="date">28/09/2023</div>
        <p><u>Aim:</u> Find out if the OD meter used so far ready correct values of absorbance </p>
        <p><u>Protocol:</u> Loaded equivalent sample sizes from same bacterial culture into <b>Multiplate OD Reader</b> (default OD meter so far) and <b>OD600 Machine </b>(correctly calibrated machine).</p>
        <p><u>Results:</u> 
        <table class="equal-width-table">
          <thead>
            <tr>
              <th> Multiplate </th>
              <th> OD600 Machine </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td> OD = 0,667 </td>
              <td> OD = 2,447 </td>
            </tr>
          </tbody>
        </table> Showing the <b>Multiplate OD Reader</b> used to measure ODs so far is very deficient. Starting from this experiment all ODs will be measured using <b>OD600 Machine</b>.</p>
        <br></br>

        <h2 id="Viability-Assay1_s"> Viability Assay</h2>
        <div className="date">01/10/2023: <mark className="date-text">Primary Culture of SpaC-D1D2, SpaC-D1, SapC</mark></div>
        <div className="date">02/10/2023: <mark className="date-text">Secondary Culture</mark>
        <br/><u>Conditions:</u>
          <table class="table-with-headers">
            <thead>
              <tr>
                <th>D1&D2</th>
                <th>D2</th>
                <th>unshortened SpaC</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Th+/IPTG-</td>
                <td>Th+/IPTG-</td>
                <td>Th+/IPTG-</td>
              </tr>
              <tr>
                <td>Th-/IPTG+</td>
                <td>Th-/IPTG+</td>
                <td>Th-/IPTG+</td>
              </tr>
              <tr>
                <td>Th-/IPTG-</td>
                <td>Th-/IPTG-</td>
                <td>Th-/IPTG-</td>
              </tr>
              <tr>
                <td>Th+/IPTG+</td>
                <td>Th+/IPTG+</td>
                <td>no</td>
              </tr>
            </tbody>
          </table> 
        </div>

        <div className="date">02/10/2023: <mark className="date-text">Induction</mark>
        <br/>Secondary Cultutres induced with IPTG when OD reached 0,4</div>
        <div className="date">02/10/2023: <mark className="date-text"> Viability Assay</mark></div>
        <p><u>ODs:</u>
        <table class="table-with-headers">
          <thead>
            <tr>
              <th></th>
              <th>D1&D2</th>
              <th>D2</th>
              <th>unshortened SpaC</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Th+/IPTG-</th> 
              <td>1,326</td>
              <td>1,35</td>
              <td>0,817</td>
            </tr>
            <tr>
              <th>Th-/IPTG+</th> 
              <td>1,2</td>
              <td>1</td>
              <td>1,35</td>
            </tr>
            <tr>
              <th>Th-/IPTG-</th> 
              <td>1,55</td>
              <td>1,47</td>
              <td>1,5</td>
            </tr>
            <tr>
              <th>Th+/IPTG+</th> 
              <td>0,82</td>
              <td>0,836</td>
              <td> - </td>
            </tr>
          </tbody>
</table></p>
        <p><u>Aim:</u> Check for the viability of bacteria given different conditions. This will be used to establish the proportion of bacteria that adhere to mucus.</p>
        <p><u>Protocol:</u> Viability Assay (dilution at 1:100 and 1:1000)</p>
        <p><u>Results:</u> See in Results:<a href="https://2023.igem.wiki/epfl/results#Mucus_Binding_D1D2_s"> First mucus-binding experiment </a></p>
        <br></br>

        <h2 id="Western2-SpaC_s"> Western Blot of Viability Assay </h2>
        <div className="date">03/10/2023</div>
        <p><u>Aim:</u> Check for the viability of bacteria given different conditions.</p>
        <p><u>Protocol:</u> Western Blot</p>
        <p>Loading maps:</p>
        <table class="equal-width-table">
          <thead>
            <tr>
              <th> Well 1 </th>
              <th> 2 </th>
              <th> 3 </th>
              <th> 4 </th>
              <th> 5 </th>
              <th> 6 </th>
              <th> 7 </th>
              <th> 8 </th>
              <th> 9 </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td> Ladder </td>
              <td> - </td>
              <td> D1D2 Th+/IPTG+ </td>
              <td> - </td>
              <td> D1D2 Th-/IPTG+ </td>
              <td> - </td>
              <td> D1D2 Th+/IPTG- </td>
              <td> - </td>
              <td> D1D2 NC</td>
            </tr>
          </tbody>
        </table>
        <table class="equal-width-table">
          <thead>
            <tr>
              <th> Well 1 </th>
              <th> 2 </th>
              <th> 3 </th>
              <th> 4 </th>
              <th> 5 </th>
              <th> 6 </th>
              <th> 7 </th>
              <th> 8 </th>
              <th> 9 </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td> Ladder </td>
              <td> - </td>
              <td> D2 Th+/IPTG+ </td>
              <td> - </td>
              <td> D2 Th-/IPTG+ </td>
              <td> - </td>
              <td> D2 Th+/IPTG- </td>
              <td> - </td>
              <td> D2 NC</td>
            </tr>
          </tbody>
        </table>
        <table class="equal-width-table">
          <thead>
            <tr>
              <th> Well 1 </th>
              <th> 2 </th>
              <th> 3 </th>
              <th> 4 </th>
              <th> 5 </th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td> SpaC Th+/IPTG+ </td>
              <td> - </td>
              <td> SpaC Th-/IPTG+ </td>
              <td> - </td>
              <td> SpaC Th+/IPTG- </td>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </tbody>
        </table>
        
        <p><u>Results:</u>Western Blot and PonceauS of SpaC incubated with Glucose untill different time points </p>
        <p>SpaC Western Blot:</p>
        <img src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/viability-expression-induction-spac-western.jpg"
              style={{
                paddingTop: "15px",
                paddingBottom: "15px",
                width: "45%",
                height: "auto",
              }}
              alt="Result Figure"/>
        <p>SpaC PonceauS:</p>
        <img src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/viability-expression-induction-spac-ponceau-s.jpg"
              style={{
                paddingTop: "15px",
                paddingBottom: "15px",
                width: "45%",
                height: "auto",
              }}
              alt="Result Figure"/>
        <p>D1&D2 Western Blot:</p>
        <img src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/viability-expression-induction-d1d2-western.jpg"
              style={{
                paddingTop: "15px",
                paddingBottom: "15px",
                width: "45%",
                height: "auto",
              }}
              alt="Result Figure"/>
        <p>D1&D2 PonceauS:</p>
        <img src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/viability-expression-induction-d1d2-ponceau-s.jpg "
              style={{
                paddingTop: "15px",
                paddingBottom: "15px",
                width: "45%",
                height: "auto",
              }}
              alt="Result Figure"/>
        <p>D2 Western Blot:</p>
        <img src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/viability-expression-induction-d2-western.jpg"
              style={{
                paddingTop: "15px",
                paddingBottom: "15px",
                width: "45%",
                height: "auto",
              }}
              alt="Result Figure"/>
        <p>D2 PonceauS:</p>
        <img src="https://static.igem.wiki/teams/4888/wiki/clean-results-flo/viability-expression-induction-d2-ponceau-s.jpg"
              style={{
                paddingTop: "15px",
                paddingBottom: "15px",
                width: "45%",
                height: "auto",
              }}
              alt="Result Figure"/>
        <br></br>

        <h2 id="Viability-Assay2_s"> Viability Assay</h2>
        <div className="date">02/10/2023: <mark className="date-text">Primary Culture of SpaC-D1D2, SpaC-D1</mark></div>
        <div className="date">03/10/2023: <mark className="date-text">Secondary Culture</mark>
        <br/><u>Conditions:</u>
          <table class="table-with-headers">
            <thead>
              <tr>
                <th>D1&D2</th>
                <th>D2</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Th+/IPTG+</td>
                <td>Th+/IPTG+</td>
              </tr>
            </tbody>
          </table> 
        </div>

        <div className="date">03/10/2023: <mark className="date-text">Induction</mark>
        <br/>Secondary Cultutres induced with IPTG when OD reached 0,4.</div>
        <div className="date">03/10/2023: <mark className="date-text"> Viability Assay</mark></div>
        <p><u>ODs:</u>
        <table class="table-with-headers">
          <thead>
            <tr>
              <th></th>
              <th>D1&D2</th>
              <th>D2</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Th+/IPTG+</th> 
              <td>0,845</td>
              <td>0,614</td>
            </tr>
          </tbody>
</table></p>
        <p><u>Aim:</u> Find appropriate dilutions for D2 and D1D2.</p>
        <p><u>Protocol:</u> Viability Assay (dilution at 1:1 1:10 1:100)</p>
        <p><u>Results:</u> Between a 1:10 and 1:100 dilution is appropriate.</p>
        <p><p><u>Results:</u> See in Results: <a href="https://2023.igem.wiki/epfl/results#Mucus_Binding2_D1D2_s">Second mucus-binding experiment </a></p></p>
        <br></br>

        <h2 id="Immunofluorescence2-SpaC_s"> ImmunoFluorescence Experiment </h2>
        <div className="date">03/10/2023: <mark className="date-text">Primary Culture of D2, D1D2, SpaC</mark></div>
        <div className="date">04/10/2023: <mark className="date-text">Secondary Culture</mark>
        <br/><u>Conditions:</u>
          <table class="table-with-headers">
            <thead>
              <tr>
                <th>D1&D2</th>
                <th>D2</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Th+/IPTG+</td>
                <td>Th+/IPTG+</td>
              </tr>
              <tr>
                <td>Th-/IPTG+</td>
                <td>Th-/IPTG+</td>
              </tr>
              <tr>
                <td>Th-/IPTG-</td>
                <td>Th-/IPTG-</td>
              </tr>
              <tr>
                <td>Th+/IPTG+</td>
                <td>Th+/IPTG+</td>
              </tr>
            </tbody>
          </table> </div>
        <div className="date">04/10/2023: <mark className="date-text">Induction </mark>
        <br/>Secondary Cultutres induced with IPTG when OD reached 0,4</div>
        <div className="date">04/10/2023: <mark className="date-text">ImmunoFluorescence Experiment</mark></div>
        <p><u>Aim:</u> Check surface expression of SpaC, D2 and D1D2 domains protein </p>
        <p><u>Protocol:</u> Immunofluorescence for surface expression verification</p>
        <p><u>Results:</u> See in Results:<a href="https://2023.igem.wiki/epfl/results#Surface_Expression_D1D2_s"> Surface expression of D2 and D1D2</a>.</p>
        <br></br>

        <h2 id="Viability-Assay3_s"> Viability Assay</h2>
        <div className="date">05/10/2023: <mark className="date-text">Primary Culture of SpaC-D1D2, SpaC-D1</mark></div>
        <div className="date">06/10/2023: <mark className="date-text">Secondary Culture</mark>
        <br/><u>Conditions:</u>
          <table class="table-with-headers">
            <thead>
              <tr>
                <th>D1&D2</th>
                <th>D2</th>
                <th>unshortened SpaC</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Th+/IPTG+</td>
                <td>Th+/IPTG+</td>
                <td>Th-/IPTG+</td>
              </tr>
            </tbody>
          </table> 
        </div>

        <div className="date">06/10/2023: <mark className="date-text">Induction</mark>
        <br/>Secondary Cultutres induced with IPTG when OD reached 0,4</div>
        <div className="date">06/10/2023: <mark className="date-text"> Viability Assay</mark></div>
        <p><u>ODs:</u>
        <table class="table-with-headers">
          <thead>
            <tr>
              <th></th>
              <th>D1&D2</th>
              <th>D2</th>
              <th>unshortened SpaC</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Th-/IPTG+</th> 
              <td> - </td>
              <td> - </td>
              <td>1,045</td>
            </tr>
            <tr>
              <th>Th+/IPTG+</th> 
              <td>1,144</td>
              <td>0,868</td>
              <td> - </td>
            </tr>
          </tbody>
</table></p>
        <p><u>Aim:</u> Check for the viability of bacteria given different conditions. This will be used to establish the proportion of bacteria that adhere to mucus.</p>
        <p><u>Protocol:</u> Viability Assay (dilution at 1:2 1:10 1:100)</p>
        <p><u>Results:</u> See in Results: <a href="https://2023.igem.wiki/epfl/results#Third_Experiment_D1D2_s">Third mucus-binding experiment </a></p>
        <br></br>

<h2 id="Halflife3-SpaC_s"> Half-Life of shortened SpaC protein - D2  and D1&D2 domain </h2>
<div className="date">26/09/2023: <mark className="date-text">Primary Culture</mark></div>
<div className="date">27/09/2023: <mark className="date-text">Secondary Culture</mark></div>
<div className="date">26/09/2023: <mark className="date-text"> Culture OD Evolution Assay</mark></div>
<div className="date">05/10/2023: <mark className="date-text"> Western Blot for Half-Life</mark></div>

<p><u>Aim:</u> Determine half-life of SpaC - D2 and SpaC - D1D2</p>
<p><u>Protocol:</u> Half-life</p>
        <p>Loading maps:</p>
        <table class="equal-width-table">
          <thead>
            <tr>
              <th> Well 1 </th>
              <th> 2 </th>
              <th> 3 </th>
              <th> 4 </th>
              <th> 5 </th>
              <th> 6 </th>
              <th> 7 </th>
              <th> 8 </th>
              <th> 9 </th>
              <th> 10 </th>
              <th> 11 </th>
              <th> 12 </th>
              <th> 13 </th>
              <th> 14 </th>
              <th> 15 </th>
              <th> 16 </th>
              <th> 17 </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td> Ladder </td>
              <td> - </td>
              <td> D2 0h </td>
              <td> - </td>
              <td> D2 24h </td>
              <td> - </td>
              <td> D2 48h </td>
              <td> - </td>
              <td> D2 72h </td>
              <td> - </td>
              <td> D2 120h </td>
              <td> - </td>
              <td> D2 148h </td>
              <td> - </td>
              <td> D2 172 </td>
              <td> - </td>
              <td> D2 196</td>
            </tr>
          </tbody>
        </table>
        <table class="equal-width-table">
          <thead>
            <tr>
              <th> Well 1 </th>
              <th> 2 </th>
              <th> 3 </th>
              <th> 4 </th>
              <th> 5 </th>
              <th> 6 </th>
              <th> 7 </th>
              <th> 8 </th>
              <th> 9 </th>
              <th> 10 </th>
              <th> 11 </th>
              <th> 12 </th>
              <th> 13 </th>
              <th> 14 </th>
              <th> 15 </th>
              <th> 16 </th>
              <th> 17 </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td> Ladder </td>
              <td> - </td>
              <td> D1D2 0h </td>
              <td> - </td>
              <td> D1D2 24h </td>
              <td> - </td>
              <td> D1D2 48h </td>
              <td> - </td>
              <td> D1D2 72h </td>
              <td> - </td>
              <td> D1D2 120h </td>
              <td> - </td>
              <td> D1D2 148h </td>
              <td> - </td>
              <td> D1D2 172 </td>
              <td> - </td>
              <td> D1D2 196</td>
            </tr>
          </tbody>
        </table>
<Figure9 /><Figure10 />
<p><u>Results:</u> After calculations, half life of shortened SpaC - D2 domain is 119,5h (or 5days)</p>
<p>After calculations, half life of shortened SpaC - D1 & D2 domain is 113h (or 4days 17h) </p>

<br></br>

        <br></br>
        <br></br>
      </div>
    </div>
  );
};

export default Article;
